/**
 * @changelog
 *
 * 2026-10-27 (0.1.0) (jhoward)
 *   - Add smsOptedOut(), which reads how to text START out of a response that refused to send a code because the
 *     guest's number stopped texts from us (409, errors: ['SMS_OPTED_OUT']).
 */

import type { FetchResponse } from '@framework/defs/framework';

/**
 * How a guest who texted STOP starts texts again - only they can, by texting the keyword to our number. number is
 * formatted to read, e.g. (775) 555-0123, and href opens a text with the keyword already typed; either is null when
 * the server has no number to show.
 */
export interface SmsOptIn {
  keyword: string;
  number: string | null;
  href: string | null;
}

export default function smsOptedOut(response: FetchResponse & { status?: number; data?: unknown }): SmsOptIn | null {
  if (409 !== response.status || !Array.isArray(response.errors) || !response.errors.includes('SMS_OPTED_OUT')) {
    return null;
  }

  return (response.data as { sms_opt_in?: SmsOptIn } | undefined)?.sms_opt_in ?? null;
}
